import React, { useEffect } from "react";
import api from "../services/api";
import auth from "../services/auth";


export default function Documents(){


  useEffect(() => {
    api.get("documents", {headers: auth.token()}).then((response) => {
      console.log(response.data.data);
    });
  }, []);
  return(<h1>Documents</h1>);
}